import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { AppDispatch } from 'stores/store';
import { useStoreData } from 'stores/hooks';
import { RequestStatus } from 'stores/common';
import {
  getTimeslotsAsync,
  getCurrentTimeslots,
  getCurrentTimeslotsRequestStatus,
  getUpdateOrCreateTimeslotsRequestStatus,
  updateOrCreateTimeslotAsync,
} from './timeslotsSlice';
import { TimeSlot } from './timeslotsTypes';

export function useCurrentTimeslots(doctorID?: string) {
  return useStoreData(
    getCurrentTimeslots,
    getCurrentTimeslotsRequestStatus,
    getTimeslotsAsync,
    doctorID,
  );
}

export function useUpdateOrCreateTimeslot(): [(timeslotData: TimeSlot) => void, RequestStatus] {
  const dispatch = useDispatch<AppDispatch>();
  const requestStatus = useSelector(getUpdateOrCreateTimeslotsRequestStatus);

  const updateOrCreate = useCallback((timeslotData: TimeSlot) => {
    dispatch(updateOrCreateTimeslotAsync(timeslotData));
  }, [dispatch]);

  return [updateOrCreate, requestStatus];
}
